import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=42f0f5df&scoped=true&lang=pug&"
import script from "./Conversation.vue?vue&type=script&lang=js&"
export * from "./Conversation.vue?vue&type=script&lang=js&"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=42f0f5df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f0f5df",
  null
  
)

export default component.exports